let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("hal1M")).then(() => parcelRequire('d9NM7'));